export default __webpack_public_path__ + "static/media/company.926b5580.png";